import {NgModule} from '@angular/core';
import {SharedModule} from '../shared/shared.module';
import {ThroughputDatatableComponent} from './throughput-datatable.component';
import {ThroughputService} from './throughput.service';
import {ThroughputFormComponent} from './throughput-form.component';
import {ProductModule} from '../product/product.module';
import {BsDatepickerModule} from 'ngx-bootstrap';

@NgModule({
  declarations: [
    ThroughputDatatableComponent,
    ThroughputFormComponent
  ],
  exports: [
    ThroughputDatatableComponent,
    ThroughputFormComponent
  ],
  imports: [
    SharedModule,
    ProductModule,
    BsDatepickerModule.forRoot(),
  ],
  providers: [
    ThroughputService
  ]
})
export class ThroughputModule {}



// WEBPACK FOOTER //
// /var/jenkins_home/workspace/brands-compart-portal-frontend/checkout/src/app/components/throughput/throughput.module.ts